import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Canal de "imprima a folha" entre quem PEDE o PDF e quem TEM a folha.
 *
 * O PDF do documento é a impressão da própria prévia — não existe arquivo no servidor
 * para baixar. Quem sabe imprimir é o painel de prévia, dono dos iframes já paginados
 * pelo paged.js; quem pede é o header, que não os alcança (são irmãos na árvore). Daí
 * este canal, em vez de o header ir atrás do iframe por conta própria.
 *
 * Um Subject, e não um signal: isto é um COMANDO que acontece uma vez, não um estado
 * que alguém lê depois. Com signal, "imprimir duas vezes seguidas" não emitiria a
 * segunda (mesmo valor) e um componente novo imprimiria sozinho ao montar.
 */
@Injectable({ providedIn: 'root' })
export class PdfPrintService {
    private readonly _requests$ = new Subject<void>();

    /** O painel escuta aqui e imprime a folha ativa. */
    public readonly requests$: Observable<void> = this._requests$.asObservable();

    /** Pede a impressão da folha. Sem painel montado, não acontece nada. */
    public request(): void {
        this._requests$.next();
    }
}
